import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { getMessageDirectionTheme } from "./Unibox/messageDirectionTheme";

/** Color de marca UNIBOX — badge, iconos y acentos de interacción */
const BRAND = "#00bbcd";
const BRAND_DARK = "#00a5b5";
const BRAND_DEEP = "#0c5c66";

export function useUniboxColors() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  return useMemo(
    () => {
      const direction = getMessageDirectionTheme(dark);

      return {
      page: theme.palette.background.default,
      panel: dark ? "#1a1f26" : "#f8fafc",
      panelAlt: dark ? "#14171b" : "#f1f5f9",
      card: theme.palette.background.paper,
      cardHover: dark ? "#353c46" : "#f8fafc",
      border: theme.palette.divider,
      textPrimary: theme.palette.text.primary,
      textMuted: theme.palette.text.secondary,
      textDim: dark ? "#94a3b8" : "#94a3b8",
      /** Nombre en lista: no leídos (marrón rojizo casi negro) vs leídos (más claro) */
      listUnreadName: dark ? "#f0e4df" : "#3d2926",
      listReadName: dark ? "#94a3b8" : "#6b7280",
      accent: dark ? "#4dd0e1" : BRAND,
      radius: "10px",
      radiusOuter: "12px",
      accentSoft: dark ? "rgba(0, 187, 205, 0.22)" : "rgba(0, 187, 205, 0.14)",
      accentBorder: dark ? "#4dd0e1" : BRAND_DARK,
      selected: dark ? "rgba(0, 187, 205, 0.35)" : "rgba(0, 187, 205, 0.22)",
      selectedBorder: dark ? "#4dd0e1" : BRAND_DARK,
      filterSelectedBg: dark ? "rgba(0, 187, 205, 0.32)" : "rgba(0, 187, 205, 0.24)",
      filterSelectedColor: dark ? "#e0f7fa" : BRAND_DEEP,
      sentBg: direction.sent.chipBg,
      sentText: direction.sent.text,
      recvBg: direction.received.chipBg,
      recvText: direction.received.text,
      sentTone: direction.sent.tone,
      recvTone: direction.received.tone,
      unreadDot: dark ? "#4dd0e1" : BRAND,
      toolbarBtn: dark ? "#353c46" : "#fff",
      toolbarBtnActive: dark ? "rgba(0, 187, 205, 0.28)" : "rgba(0, 187, 205, 0.14)",
      toolbarBtnHover: dark ? "#3f4754" : "#f8fafc",
      emailCanvasBg: dark ? "#262b33" : "#ffffff",
      iframeBg: dark ? "#262b33" : "#ffffff",
      emailBodyText: dark ? "#e2e8f0" : "#1e293b",
      metaBg: dark ? "#262b33" : "#f8fafc",
      metaBorder: dark ? "rgba(148, 163, 184, 0.2)" : "#f1f5f9",
      headerBg: dark ? "#1f252d" : theme.palette.background.paper,
      listSelected: dark ? "rgba(0, 187, 205, 0.35)" : "rgba(0, 187, 205, 0.22)",
      overlayBg: dark ? "rgba(31, 37, 45, 0.96)" : "rgba(255, 255, 255, 0.92)",
      shadowSm: dark
        ? "0 1px 3px rgba(0, 0, 0, 0.45)"
        : "0 1px 2px rgba(15, 23, 42, 0.04)",
      shadowMd: dark
        ? "0 8px 30px rgba(0, 0, 0, 0.5)"
        : "0 8px 30px rgba(15, 23, 42, 0.06)",
      shadowActive: dark
        ? "0 4px 16px rgba(0, 187, 205, 0.3)"
        : "0 4px 14px rgba(0, 187, 205, 0.2)",
      isDark: dark,
    };
    },
    [theme, dark]
  );
}
